import React from 'react'
import ChevronIcon from './ChevronIcon'

import { ReactComponent as GlassesIcon } from 'assets/svg/glasses.svg'
import { ReactComponent as SunglassesIcon } from 'assets/svg/sunglasses.svg'
import { ReactComponent as LensIcon } from 'assets/svg/lens.svg'

import { Border, Color, Gap, Product, Responsive, Size } from 'const'
import styled from 'styled-components'
import ProductBox from './ProductBox'

const OldProduct = ({ products, dev_return_date, dev_return_code, onClick }) => {
  const reason = ['紛失・買取', '通常返却', '返却']

  const reasonText = reason.includes(dev_return_code) ? `にご${dev_return_code}` : `に${dev_return_code}`

  const displayDate = dev_return_date ? `${dev_return_date} ${reasonText}` : '-'

  const renderItems = products.map((product) => {
    const isLens = product.dev_product_classification === '20'

    const info = isLens ? (product.dev_rl === '左' ? 'レンズL' : 'レンズR') : 'フレーム'

    const name = `${product.dev_brand} ${product.abbreviation || ''}`

    const productType = isLens ? 'lens' : 'frame'

    return <ProductBoxWrapper key={product.dev_purchase_detailid} productType={productType} info={info} name={name} />
  })

  return (
    <Box role="button" tabIndex={0} onClick={onClick}>
      <Header>
        <Title>{displayDate}</Title>
        <Navigation>
          <ChevronIcon />
        </Navigation>
      </Header>
      <Body>{renderItems}</Body>
    </Box>
  )
}

const Box = styled.div`
  background: ${Color.BACKGROUND.BASE};
  border: 1px solid ${Color.BORDER.MENU};
  border-radius: ${Border.MENU.RADIUS};
  padding: 10px 20px 30px;
  display: flex;
  flex-direction: column;
  gap: ${Gap.XL};
  text-decoration: none;
  cursor: pointer;
  position: relative;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${Color.BORDER.MENU};
  gap: ${Gap.LG};
  padding: 16px 0;
`

const Title = styled.div`
  flex: 1;
  font-size: ${Size.FONT.LG};
  font-weight: 700;
  @media screen and (max-width: ${Responsive.XS.DOWN}px) {
    font-size: ${Size.FONT.BIGGER};
  }
`

const Navigation = styled.div``

const Body = styled.div`
  display: flex;
  flex-direction: column;
`

// const Summary = styled.div`
//   display: grid;
//   gap: ${Gap.MD};
//   grid-template-columns: 1fr;
//   padding-bottom: ${Gap.XXL};
// `

export const ProductBoxWrapper = ({ productType, name, info }) => {
  switch (productType) {
    case Product.TYPES.FRAME:
      return <ProductBox svg={<GlassesIcon />} info={info} text={name} />
    case Product.TYPES.SUNGALSSES:
      return <ProductBox svg={<SunglassesIcon />} info={info} text={name} />
    case Product.TYPES.LENS:
      return <ProductBox svg={<LensIcon />} info={info} text={name} />
    default:
      return <></>
  }
}

export default OldProduct
